/**
 * List of events used by static content data widget
 *
 */
export const staticContentData = {
  STATIC_CONTENT_DATA_READY: 'staticContentData.InfoReady'
}
